import * as React from 'react';
import { Button, MenuItem, Menu, Divider } from '@mui/material';

import { IOptionIcon } from 'common/ui/interfaces/selectors';

import styles from './styles.module.scss';

type InputProps = {
  children: string;
  onSelected: (item: IOptionIcon) => void;
  label?: string;
  items: IOptionIcon[];
  classes?: {
    buttonClass?: string;
  };
  endIcon?: React.ReactNode;
  listOfDisabled?: string[];
};

export default function PositionedMenu({
  children,
  onSelected,
  items,
  label,
  classes,
  endIcon,
  listOfDisabled,
}: InputProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (item: IOptionIcon) => {
    onSelected(item);
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        classes={{
          root: classes?.buttonClass || styles.button,
        }}
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={endIcon}
      >
        {children}
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            '&': {
              border: '1px solid #D0D3D6',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
              borderRadius: '1px',
            },
            '& ul': {
              padding: 0,
              margin: 0,
            },
            '& hr': {
              margin: '-4px 4px 2px',
            },
          },
        }}
      >
        {label && (
          <MenuItem classes={{ root: styles.menuTitle }}>
            <b>{label}</b>
          </MenuItem>
        )}
        {label && <Divider />}
        {items.map((item) => (
          <MenuItem
            key={item.value}
            className={styles.menuTitle}
            onClick={() => {
              handleSelect(item);
            }}
            disabled={listOfDisabled?.includes(item.value)}
          >
            {item.icon && <span>{item.icon}</span>}
            <span className={styles.title}>{item.label}</span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
